import React from "react";
import Comments from "@components/postComponents/comments/Comments";
import UserDetails from "@components/postComponents/postDetails/UserDetails";
import Description from "@components/postComponents/postDetails/Description";
import PostShareBar from "@components/postComponents/postDetails/PostShareBar";

export default function PostDetailsContainer({
  post,
  setDownloadAppModalOpen,
  setShareLinksModal,
  shareLinksModal,
}) {
  return (
    <div className="w-1/3 hidden lg:flex flex-col">
      <UserDetails post={post} />
      {post.title ? <Description title={post.title} /> : null}
      <PostShareBar
        post={post}
        setDownloadAppModalOpen={setDownloadAppModalOpen}
        setShareLinksModal={setShareLinksModal}
        shareLinksModal={shareLinksModal}
      />
      <Comments post={post} setDownloadAppModalOpen={setDownloadAppModalOpen} />
    </div>
  );
}
